export function scrollBarWidth() {
    let div = document.createElement('div');
    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    div.style.visibility = 'hidden';
    document.body.appendChild(div);
    let scrollWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return scrollWidth;
}

export function hasScrollbar() {

    if (typeof window.innerWidth === 'number')
        return window.innerWidth > document.documentElement.clientWidth;

    let rootElem = document.documentElement || document.body;

    let overflowStyle;

    if (typeof rootElem.currentStyle !== 'undefined')
        overflowStyle = rootElem.currentStyle.overflow;

    overflowStyle = overflowStyle || window.getComputedStyle(rootElem, '').overflow;

    let overflowYStyle;

    if (typeof rootElem.currentStyle !== 'undefined')
        overflowYStyle = rootElem.currentStyle.overflowY;

    overflowYStyle = overflowYStyle || window.getComputedStyle(rootElem, '').overflowY;

    let contentOverflows = rootElem.scrollHeight > rootElem.clientHeight
    let overflowShown    = /^(visible|auto)$/.test(overflowStyle) || /^(visible|auto)$/.test(overflowYStyle);
    let alwaysShowScroll = overflowStyle === 'scroll' || overflowYStyle === 'scroll';

    return (contentOverflows && overflowShown) || (alwaysShowScroll)
}

